// extracted by mini-css-extract-plugin
export default {"productGallery":"TP-z","inQuickShop":"UP-z"};